import { createSlice } from "@reduxjs/toolkit";
import {isNullOrEmpty} from "../../utils/isNullOrEmpty";

const initialState = {
  isOpen: false,
  tableOfContents: {},
  selectedItem: {},
  activeItem: {}
};

const tableOfContentsSlice = createSlice({
  name: "tableOfContents",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.tableOfContents = {};
      state.activeItem = {};
      state.selectedItem = {};
      state.isOpen = false;
    },
    setTableOfContents: (state, action) => {
      const payload = action.payload;
      state.tableOfContents = payload;
      if (!isNullOrEmpty(payload) && !isNullOrEmpty(payload.children)) {
        state.activeItem = payload.children[0];
      }
    },
    setSelectedMenuItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    resetSelectedMenuItem: (state, action) => {
      state.selectedItem = {};
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    }
  },
});

export const {
  closeModal,
  openModal,
  setTableOfContents,
  setSelectedMenuItem,
  resetSelectedMenuItem,
  setActiveItem,
} = tableOfContentsSlice.actions;

export default tableOfContentsSlice.reducer;
